// Deprecated, import directly from the component folder now.
export * from '../../Autofill/Autofill';
//# sourceMappingURL=BaseAutoFill.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/pickers/AutoFill/BaseAutoFill.js
// module id = 806
// module chunks = 0